import type { ExportOut } from "../api/client";
import { t } from "../i18n/t";
import { exportKindLabel, exportStatusLabel } from "../lib/exports";
import { formatDateTime } from "../lib/format";

/** Ordered exports with their status, the error of a failed one, and a download link when done. */
export function ExportTable({
  exports,
  caption,
  kommuneName,
  schoolName,
  downloadHref,
}: {
  exports: readonly ExportOut[];
  caption: string;
  kommuneName: (nummer: string) => string;
  schoolName: (schoolId: string) => string;
  downloadHref: (e: ExportOut) => string;
}) {
  return (
    <div className="table-wrap">
      <table className="data-table">
        <caption className="visually-hidden">{caption}</caption>
        <thead>
          <tr>
            <th scope="col">{t("exports.colCreated")}</th>
            <th scope="col">{t("exports.colKind")}</th>
            <th scope="col">{t("exports.colKommune")}</th>
            <th scope="col">{t("exports.colScope")}</th>
            <th scope="col">{t("exports.colStatus")}</th>
            <th scope="col">{t("exports.colFile")}</th>
          </tr>
        </thead>
        <tbody>
          {exports.map((e) => (
            <tr key={e.id}>
              <td>{formatDateTime(e.created_at)}</td>
              <td>{exportKindLabel(e.kind)}</td>
              <td>{kommuneName(e.kommunenummer)}</td>
              <td>{e.school_id ? schoolName(e.school_id) : t("exports.scopeKommune")}</td>
              <td>
                <span className={`run-status run-${e.status}`}>{exportStatusLabel(e.status)}</span>
                {e.status === "failed" && e.error && <p className="error-text">{e.error}</p>}
              </td>
              <td>
                {e.status === "succeeded" ? (
                  <a
                    href={downloadHref(e)}
                    aria-label={t("exports.downloadLabel", { filename: e.filename })}
                  >
                    {t("exports.download")}
                  </a>
                ) : (
                  t("common.dash")
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
